export const setDarkMode = (isActive: boolean): void => {
    if (isActive) {
        document.documentElement.setAttribute('dark-mode', String(true));
    } else {
        document.documentElement.removeAttribute('dark-mode');
    }
};
